import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {AppContainer} from 'react-hot-loader';
import {loadableReady} from '@loadable/component';
import './sass/app.scss';

require('dotenv').config();

const render = (Component) => {
  ReactDOM.render(
    <React.StrictMode>
      <AppContainer>
        <Component />
      </AppContainer>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

if (process.env.NODE_ENV === 'production') {
  loadableReady(() => {
    render(App);
  });
} else {
  render(App);
}

if (module.hot) {
  module.hot.accept('./App', () => {
    render(require('./App').default);
  });
}
